<template>
  <div class="supplement">
    <div class="content">
      <Top class="top" name="批量修改积分">
        <template slot="right">
          <div class="tips_title">
            <img
              src="@/assets/images/tishiicon.png"
              style="display: inline-block; cursor: pointer; margin-right: 8px"
            />
            <span style=""
              >此功能需要导入文件批量修改积分，如果仅针对单个会员修改积分，可以前往会员明细里面修改</span
            >
          </div>
        </template>
      </Top>
      <!-- 上传按钮 -->
      <div class="uploadXBox">
        <el-button
          type="primary"
          size="small"
          @click="handleUploadFiles"
          class="uploadBtn"
        >
          导入文件
        </el-button>
      </div>
      <!-- 下载按钮 -->
      <div class="downloadBox" @click="downloadTemplate">
        <el-button type="text" size="small" style="color: #1f4287">
          下载模板
        </el-button>
        <div class="show_var">
          <div class="showYin">
            <img class="detailImg" src="@/assets/images/excel.png" />
          </div>
        </div>
      </div>

      <!-- 表格不统一重写 -->
      <div style="margin-top: 20px">
        <el-table
          ref="multipleTable"
          :data="importDetail"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F4F4F4', height: '42px' }"
          style="width: 100%; border: 1px solid #efefef"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div style="margin: 20px">
              <img
                src="@/assets/images/nodata.png"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  cursor: pointer;
                "
              />
              <span style="color: #999999" class="nodata">没有数据哦~</span>
            </div>
          </template>
          <el-table-column
            prop="fileOldName"
            label="文件名称"
          ></el-table-column>
          <el-table-column prop="uploadTime" label="时间"></el-table-column>
          <el-table-column prop="platform" label="变更人数"></el-table-column>
          <el-table-column prop="addIntegrate" label="变更积分">
            <template slot-scope="scope">
              <span>{{
                +scope.row.addIntegrate + +scope.row.subIntegrate
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="uploadState" label="执行状态">
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.uploadState == '执行中'
                    ? 'dot dotColorTwo'
                    : scope.row.uploadState == '执行失败'
                    ? 'dot dotColorFour'
                    : scope.row.uploadState == '执行完成'
                    ? 'dot dotColorThree'
                    : scope.row.uploadState == '未执行'
                    ? 'dot dotColorFive'
                    : ''
                "
              ></span
              >&nbsp;
              <span>{{ scope.row.uploadState }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="table1Total"
        style="text-align: right; margin-top: 30px"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :current-page="currentPage"
        @current-change="currentChange"
        @size-change="handleSizeChange"
        next-click="nextClick"
      ></el-pagination>
    </div>
    <!-- 文件上传弹窗 -->
    <el-dialog
      title="上传文件"
      :visible.sync="uploadDialog"
      width="570px"
      :before-close="handleClose"
      class="upload_dialog"
    >
      <div>
        <div class="uploadBox">
          <div class="select-line">
            <div class="item-name">选择会员卡</div>
            <el-select
              style="width: 120px"
              v-model="formDataList.scoresCardId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in memberCardList"
                :key="item.scoresCardId"
                :label="item.cardName"
                :value="item.scoresCardId"
              ></el-option>
            </el-select>
          </div>
          <div class="item_descOne">
            <span>
              <i style="color: #7489b5" class="iconfont iconjinggao"></i
              >文件格式：excel, csv格式，文件大小不超过50M大小
            </span>
          </div>
          <el-upload
            class="upload"
            :action="uploadUrl"
            :file-list="fileList"
            :limit="1"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            :auto-upload="false"
            ref="upload"
            accept="excel"
          >
            <div
              style="
                width: 100%;
                height: 130px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #f9fafb;
              "
            >
              <div class="upload-btn">
                <img src="@/assets/images/sms/btn_selectWord.png" alt="" />
                <div
                  v-if="!isupload"
                  class="el-upload__text"
                  style="color: #1f4287"
                >
                  选择文件上传
                </div>
              </div>
              <div
                style="
                  float: right;
                  width: 300px;
                  height: 87px;
                  padding: 20px 0;
                "
                @click.stop=""
                v-if="isupload"
                class="procontain"
              >
                <div class="proInfo" :style="{ color: stateColor }">
                  {{ loadState }}
                  <i
                    v-if="success === false"
                    @click="reload($event)"
                    class="el-icon-refresh"
                    style="
                      display: inline-block;
                      margin: 0 3px;
                      color: #999;
                      height: 20px;
                      line-height: 20px;
                      vertical-align: top;
                    "
                  ></i>
                  <div class="proclose" @click="closePro($event)">
                    <i style="color: #999" class="el-icon-close"></i>
                  </div>
                </div>
                <el-progress
                  :percentage="process"
                  v-if="success === ''"
                ></el-progress>
                <el-progress
                  :percentage="process"
                  status="success"
                  v-if="process === 100 && success === true"
                ></el-progress>
                <el-progress
                  :percentage="process"
                  status="exception"
                  v-if="process === 100 && success === false"
                ></el-progress>
              </div>
            </div>
            <!-- <div class="info">
              文件格式：excel, csv格式，文件大小不超过50M大小
            </div> -->
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="up_btn" @click="uploadDialog = false">取消</el-button>
        <el-button type="primary" class="up_btn" @click="uploadFile"
          >开始上传</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getScoresCardList } from "@/api/publicController";
import Top from "@/components/top-title";
import {
  queryUploadFileRecord,
  uploadOrderFile,
} from "@/api/backstage/scoresMember";
export default {
  name: "modify_integral",
  components: {
    Top,
  },
  data() {
    return {
      process: 0,
      stateColor: "#409eff",
      success: "",
      proTimer: null,
      isupload: false,
      progressFlag: 2,
      currentPage: 1,
      currentSize: 10,
      importDetail: [],
      table1Total: 0,
      uploadUrl: "",
      fileUrl: "", //上传文件地址,
      uploadDialog: false,
      memberCardList: [],
      formDataList: {},
      fileList: [],
    };
  },
  created(){
    this.buriedPoint(1, "忠诚度管理", "忠诚度管理", "批量修改积分");
  },
  computed: {
    loadState: function () {
      //进度条状态
      if (this.success === "") {
        this.stateColor = "#409eff";
        return `上传中(%${this.process})`;
      }
      if (this.process === 100 && this.success === true) {
        this.stateColor = "#67c23a";
        return `上传成功`;
      }
      if (this.process === 100 && this.success === false) {
        this.stateColor = "#F56C6C";
        return `上传失败`;
      }
      return "";
    },
  },
  mounted() {
    this.uploadHistory();
    this.getCardList();
    // this.uploadUrl = supplyUploadBuyerFile();
  },
  methods: {
    handleUploadFiles() {
      this.fileList = [];
      this.uploadDialog = true;
    },
    //进度条
    closePro(ev) {
      this.isupload = false;
      ev.cancelBubble = true; //阻止冒泡
    },
    reload(ev) {
      // console.log(this.$refs);
      this.$refs.upload.$children[0].$el.click();
      ev.cancelBubble = true; //阻止冒泡
    },
    handleClose() {
      this.uploadDialog = false;
    },
    // 获取自己的会员卡列表
    getCardList() {
      getScoresCardList().then((res) => {
        if (res.code == 200) {
          this.memberCardList = res.data;
          // this.formDataList.scoresCardId = this.memberCardList[0].scoresCardId;
        }
      });
    },
    //点击下载模板
    downloadTemplate() {
      let url =
        "https://yunqi-cdp-1.oss-cn-shenzhen.aliyuncs.com/templateDir/ScoresImport.xls";
      let start = url.lastIndexOf(".");
      let type = url.substring(start);
      let fileName = "ScoresImport.xls";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
      console.log("77777", elem);
    },
    handleSuccess(res, file) {
      // if (res.code == 200) {
      //   this.fileUrl = URL.createObjectURL(file.raw);
      //   this.$message.success("文件上传成功");
      // }else {
      //   this.$message.error(res.message);
      // }
    },
    //上传前的事件
    beforeUpload(file) {
      let that = this;
      this.isupload = false;
      this.$nextTick(() => {
        that.process = 0;
        that.success = "";
        that.isupload = true;
        that.proTimer = setInterval(() => {
          if (that.process < 100) {
            that.process++;
          } else {
            clearInterval(that.proTimer);
          }
        }, 20);
      });
      //判断文件类型及大小大小小于5M，格式为csv或者xlsx
      let valid_type = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (file.size / 1024 / 1024 > 50 || valid_type.indexOf(file.type) == -1) {
        //文件超出大小或者不在合法文件數組中则取消上传
        this.process = 100;
        this.success = false;
        this.$message.warning("文件不合法");
        return false;
      }

      // let formData=new FormData();
      // formData.append('file', file);
      // uploadOrderFile(formData).then(res=>{
      //     if(res.code==200){
      //         this.process=100;
      //         this.success=true;
      //         this.currentPage=1;
      //         this.uploadHistory();
      //     }else{
      //         this.process=100;
      //         this.success=false;
      //     }
      // }).catch(()=>{
      //     this.process=100;
      //     that.success=false;
      // });
      // return false;
    },
    // 上传文件按钮
    uploadFile() {
      let { uploadFiles } = this.$refs.upload;
      console.log(uploadFiles);
      if (uploadFiles.length == "0") {
        this.$message.warning("请上传文件");
        return;
      }
      if (!this.formDataList.scoresCardId) {
        this.$message.warning("请选择会员卡");
        return;
      }
      var file = uploadFiles[0].raw;
      console.log(file);
      console.log(this.formDataList.scoresCardId);
      let formData = new FormData();
      formData.append("file", file);
      formData.append("scoresCareId", this.formDataList.scoresCardId);
      console.log(formData);

      this.uploadDialog = false;
      uploadOrderFile(formData)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.message);
            this.process = 100;
            this.success = true;
            this.currentPage = 1;
            this.uploadHistory();
          } else {
            this.uploadDialog = true;
            this.$message.success(res.error);
            this.process = 100;
            this.success = false;
          }
        })
        .catch(() => {
          this.process = 100;
          this.success = false;
        });
    },
    uploadHistory() {
      queryUploadFileRecord({
        pageNum: this.currentPage,
        pageSize: this.currentSize,
      })
        .then((res) => {
          this.importDetail = res.data.dataList;
          this.table1Total = res.data.pageInfo.total;
        })
        .catch(() => {});
    },
    //页码数发生改变触发
    currentChange: function (pageNum) {
      this.currentPage = pageNum;
      this.uploadHistory();
    },
    handleSizeChange(val) {
      this.currentSize = val;
      this.uploadHistory();
    },
  },
};
</script>

<style lang="scss" scoped>
.select-line {
  margin-bottom: 20px;
  .item-name {
    display: inline-block;
    padding-right: 20px;
  }
}
.supplement {
  .content {
    box-sizing: border-box;
    padding: 24px 30px;
    width: 100%;
    // height: 526px;
    background: rgba(255, 255, 255, 1);
    // border:1px solid rgba(230,230,230,1);
    box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
    border-radius: 6px;
    .tips_title {
      box-sizing: border-box;
      // padding: 7px 12px;
      display: flex;
      align-items: center;
      background: #f6f7fa;
      opacity: 1;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 400;
      color: #333333;
      margin-top: -4px;
      .icon {
        box-sizing: border-box;
        width: 10px;
        height: 10px;
        padding: 4px;
        margin-right: 4px;
        display: inline-block;
        background: #7489b5;
      }
    }
    .modify {
      font-size: 18px;
      margin-bottom: 5px;
    }
    .notice {
      box-sizing: border-box;
      padding-left: 15px;
      margin-bottom: 22px;
      width: 100%;
      height: 32px;
      line-height: 30px;
      background: rgba(248, 250, 255, 1);
      border: 1px solid rgba(172, 193, 254, 1);
      border-radius: 2px;
      span {
        color: #333;
        font-size: 12px;
      }
    }
    .uploadBox {
      width: 346px;
      height: 90px;
      margin-bottom: 20px;
    }
    .uploadXBox {
      display: inline-block;
      margin-right: 10px;
      button {
        // height: 32px;
        // line-height: 32px;
      }
    }
    .downloadBox {
      display: inline-block;
      button {
        margin: 0;
        padding: 0;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        border: none;
        outline: none;
        text-align: center;
        border-radius: 2px;
        cursor: pointer;
        transition: all 0.2s linear;
      }
      .download {
        display: flex;
        align-items: center;
        padding: 0 12px;
        margin-right: 10px;
        color: #fff;
        background-color: #5882fb;
        &:hover {
          opacity: 0.8;
        }
        &:active {
          opacity: 1;
        }
      }
      .see {
        padding: 0 16px;
        line-height: 30px;
        color: #5882fb;
        border: 1px solid rgba(88, 130, 251, 1);
        background-color: #fff;
        &:hover {
          color: #fff;
          background-color: #5882fb;
        }
        &:active {
          color: #fff;
          background-color: #3d6fff;
        }
      }
    }
    .tableBox {
      width: 100%;
      margin-top: 20px;
      text-align: center;
      .head {
        background-color: #f4f4f4 !important;
        font-size: 13px;
        color: #333333;
        height: 40px;
        font-size: 14px;
        font-weight: 500 !important;
        border-radius: 6px 6px 0px 0px;
        opacity: 1;
        th {
          flex: 1;
        }
      }
      tr {
        display: flex;
        align-items: center;
        height: 60px;
        font-size: 12px;
        color: #333;
        &:nth-child(odd) {
          background-color: #fafafa;
        }
        &:nth-child(even) {
          background-color: #fff;
        }
        td {
          flex: 1;
          line-height: 40px;
          height: 40px;
          border-right: 1px solid #f0f2f6;
          &:last-child {
            border: none;
          }
        }
      }
    }
    .showYin {
      background: #fff;
      .detailImg {
        border-radius: 6px;
        border: 1px solid #fff;
        padding: 12px;
      }
    }
    .downloadBox:hover {
      .detailImg {
        background: #fff;
        display: inline;
        margin-top: 8px;
        //  -moz-box-shadow: 10px 3px 3px #ccc;/*兼容旧版火狐，4版本之下，新版火狐这句无效*/
        //  -webkit-box-shadow: 10px 3px 3px #ccc;/*谷歌*/
        //  box-shadow:0px 0px 3px 4px #ccc;/*主流现代浏览器，基本能识别*/
        // box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.3);
        box-shadow: 0px 2px 23px 0px #e4e4e4;
      }
    }
  }
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  opacity: 1;
  display: inline-block;
}
.dotColorTwo {
  background: #ff8851;
}
.dotColorThree {
  background: #7489b5;
}
.dotColorFour {
  background: #e02020;
}
.dotColorFive {
  background: #ccc;
}
.show_var {
  position: relative;
  z-index: 100;
}
.detailImg {
  display: none;
  position: absolute;
  top: -50px;
  left: 70px;
}
</style>

<style lang="scss">
.supplement .uploadBox {
  .upload {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border: 1px solid #fcfcfc;
    border-radius: 2px;
    transition: all 0.1s;
    &:hover {
      border-color: #1f4287;
    }
    .el-upload {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      color: #999;
      .info {
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: #f9fafb;
        font-size: 12px;
      }
    }
    .progress {
      .flag {
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 40px 0 15px;
        transform: translateY(5px);
        .success {
          color: #5882fb;
        }
        .exception {
          color: #fd695b;
        }
      }
      .el-progress-bar__outer {
        height: 3px !important;
      }
      .exception .el-progress__text > i {
        color: #fd695b;
      }
      .success .el-progress__text > i {
        color: #5882fb;
      }
    }
  }
}
.upload {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border: 1px dashed #eeeeee;
  border-radius: 2px;
  transition: all 0.1s;
  &:hover {
    border-color: #5882fb;
  }
  .el-upload {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    color: #999;
    .info {
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #f9fafb;
      font-size: 12px;
    }
  }
  .progress {
    .flag {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 40px 0 15px;
      transform: translateY(5px);
      .success {
        color: #5882fb;
      }
      .exception {
        color: #fd695b;
      }
    }
    .el-progress-bar__outer {
      height: 3px !important;
    }
    .exception .el-progress__text > i {
      color: #fd695b;
    }
    .success .el-progress__text > i {
      color: #5882fb;
    }
  }
}
.procontain {
  text-align: left;
  height: 32px !important;
  .proInfo {
    height: 20px;
    line-height: 20px;
    padding-right: 50px;
    .proclose {
      float: right;
      height: 20px;
      line-height: 20px;
    }
  }
}
.up_btn {
  width: 92px;
}
.item_descOne {
  margin-bottom: 20px;
  background: #f6f7fa;
  font-size: 13px;
  border-radius: 6px;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  padding: 6px 10px;
  line-height: 18px;
  i {
    margin-right: 4px;
    font-size: 14px;
  }
}
</style>
